import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { PdfTreeGridColumnCollection, PdfTreeGridHeaderCollection, PdfTreeGridRowCollection } from './pdf-base/index';
import { PdfTreeGridStyle, PdfBorders, PdfTreeGridLayouter } from './pdf-base/index';
import { PdfLayoutElement, RectangleF, PdfLayoutFormat, PointF, SizeF } from '@syncfusion/ej2-pdf-export';
/**
 * PdfTreeGrid Class for EJ2-PDF
 */
export class PdfTreeGrid extends PdfLayoutElement {
    constructor() {
        super();
        this.treeGridSize = new SizeF(0, 0);
        this.treeColumnIndex = 0;
        this.allowRowBreakAcrossPages = true;
        this.enableHeader = true;
        this.isFitToWidth = false;
        this.columns = new PdfTreeGridColumnCollection(this);
        this.rows = new PdfTreeGridRowCollection(this);
        this.headers = new PdfTreeGridHeaderCollection(this);
        this.style = new PdfTreeGridStyle();
        this.rowHeight = 0;
    }
    //Properties
    /**
     * Gets a value indicating whether the `start cell layout event` should be raised.
     *
     * @returns {boolean} .
     * @private
     */
    // public get raiseBeginCellDraw(): boolean {
    //     // eslint-disable-next-line
    //     return (typeof this.beginCellDraw !== 'undefined' && typeof this.beginCellDraw !== null);
    // }
    /**
     * Gets a value indicating whether the `end cell layout event` should be raised.
     *
     * @returns {boolean} .
     * @private
     */
    // public get raiseEndCellDraw(): boolean {
    //     // eslint-disable-next-line
    //     return (typeof this.endCellDraw !== 'undefined' && typeof this.endCellDraw !== null);
    // }
    get size() {
        if ((this.treeGridSize.width === 0 && this.treeGridSize.height === 0)) {
            this.treeGridSize = this.calculateTreeGridSize();
        }
        return this.treeGridSize;
    }
    set size(value) {
        this.treeGridSize = value;
    }
    /**
     * `Draws` the element on the page with the specified page, 'RectangleF' class and layout format
     *
     * @private
     */
    /* eslint-disable-next-line */
    draw(arg1, arg2, arg3, arg4) {
        if (arg2 instanceof PointF && typeof arg2.width === 'undefined' && typeof arg3 === 'undefined') {
            return this.drawHelper(arg1, arg2.x, arg2.y);
        }
        else if (typeof arg2 === 'number' && typeof arg3 === 'number' && typeof arg4 === 'undefined') {
            return this.drawHelper(arg1, arg2, arg3, null);
        }
        else if (arg2 instanceof RectangleF && typeof arg2.width !== 'undefined' && typeof arg3 === 'undefined') {
            return this.drawHelper(arg1, arg2, null);
        }
        else if (arg2 instanceof PointF && typeof arg2.width === 'undefined' && arg3 instanceof PdfLayoutFormat) {
            return this.drawHelper(arg1, arg2.x, arg2.y, arg3);
        }
        else if (typeof arg2 === 'number' && typeof arg3 === 'number' && (arg4 instanceof PdfLayoutFormat || arg4 === null)) {
            const width = (arg1.graphics.clientSize.width - arg2);
            const layoutRectangle = new RectangleF(arg2, arg3, width, 0);
            return this.drawHelper(arg1, layoutRectangle, arg4);
        }
        else if (arg2 instanceof RectangleF && typeof arg2.width !== 'undefined' && typeof arg3 === 'boolean') {
            return this.drawHelper(arg1, arg2, null);
        }
        else {
            return this.drawHelper(arg1, arg2, arg3);
        }
    }
    measureColumnsWidth(bounds) {
        if (typeof bounds !== 'undefined') {
            const widths = this.columns.getDefaultWidths(bounds.width - bounds.x);
            for (let i = 0; i < this.columns.count; i++) {
                if (this.columns.getColumn(i).width < 0) {
                    this.columns.getColumn(i).width = widths[i];
                }
            }
        }
        else {
            const widths = [];
            let cellWidth = 0;
            let totalWidth = 0;
            let rowLevel = 0;
            // if(this.headers.count > 0){
            //     let colCount: number = this.headers.getHeader(0).cells.count;
            //     for(let i: number = 0; i < colCount; i++){
            //         let rowCount: number = this.headers.count;
            //         for(let j: number = 0; j < rowCount; j++){
            //             let tempWidth: number = this.headers.getHeader(j).cells.getCell(i).width;
            //             let rowWidth: number = this.initialWidth > 0 ? Math.min(this.initialWidth, tempWidth) :
            //                 tempWidth;
            //             cellWidth = Math.max(cellWidth, rowWidth);
            //         }
            //         widths.push(cellWidth);
            //     }
            // }
            const colCount = this.columns.count;
            for (let i = 0; i < colCount; i++) {
                const rowCount = this.rows.count;
                for (let j = 0; j < rowCount; j++) {
                    const tempWidth = this.rows.getRow(j).cells.getCell(i).width;
                    const rowWidth = this.initialWidth > 0 ? Math.min(this.initialWidth, tempWidth) : tempWidth;
                    cellWidth = Math.max(cellWidth, rowWidth);
                    cellWidth = Math.max(this.columns.getColumn(i).width, cellWidth);
                    if (this.columns.getColumn(i).isTreeColumn) {
                        rowLevel = Math.max(rowLevel, this.rows.getRow(j).level);
                    }
                }
                if (this.columns.getColumn(i).isTreeColumn) {
                    widths.push(cellWidth + (rowLevel * 10));
                }
                else {
                    widths.push(cellWidth);
                }
                // eslint-disable-next-line
                totalWidth += cellWidth;
                cellWidth = 0;
            }
            for (let i = 0; i < this.columns.count; i++) {
                if (this.columns.getColumn(i).width < 0) {
                    this.columns.getColumn(i).width = widths[i];
                }
            }
        }
    }
    calculateTreeGridSize() {
        let height = 0;
        const width = this.columns.width;
        for (let i = 0; i < this.headers.count; i++) {
            const row = this.headers.getHeader(i);
            height += row.height;
        }
        for (let i = 0; i < this.rows.count; i++) {
            const row = this.rows.getRow(i);
            height += row.height;
        }
        return new SizeF(width, height);
    }
    drawGrid(page, x, y, format) {
        this.initialWidth = page.graphics.clientSize.width;
        const layout = new RectangleF(0, 0, page.getClientSize().height, 0);
        return this.draw(page, layout, format);
    }
    layout(param) {
        if (this.rows.count !== 0) {
            const style = (this.rows.getRow(0).cells.count !== 0) ? this.rows.getRow(0).cells.getCell(0).style : null;
            if (!isNullOrUndefined(style) && style.borders.left.width !== 1) {
                const x = style.borders.left.width / 2;
                const y = style.borders.top.width / 2;
                if (param.bounds.x === PdfBorders.default.right.width / 2 &&
                    param.bounds.y === PdfBorders.default.right.width / 2) {
                    const newBound = new RectangleF(new PointF(x, y), new SizeF(this.size.width, this.size.height));
                    param.bounds = newBound;
                }
            }
        }
        //  this.setSpan();
        this.layouter = new PdfTreeGridLayouter(this);
        const result = this.layouter.layoutInternal(param);
        return result;
    }
}
